<div class="host-duplicate-guest">
  <div class="header" [formGroup]="form">
    <div class="form-control">
      <input 
        type="text" 
        nz-input 
        formControlName="name" 
        (compositionstart)="compositionstart('name')"
        (input)="checkDuplicateGuests('name')" 
        (compositionend)="compositionend('name')"
        [attr.placeholder]="'placeholder.add_guest.name' | translate"
        hostAutoFocus>
    </div>
    <div class="form-control">
      <input 
        type="text" 
        nz-input 
        formControlName="phone" 
        (compositionstart)="compositionstart('phone')"
        (compositionend)="compositionend('phone')"
        (input)="checkDuplicateGuests('phone')"
        [attr.placeholder]="'placeholder.add_guest.mobile' | translate"
        >
    </div>
    <div class="form-control">
      <input 
        type="text" 
        nz-input 
        formControlName="email" 
        (compositionstart)="compositionstart('email')"
        (compositionend)="compositionend('email')"
        (input)="checkDuplicateGuests('email')"
        [attr.placeholder]="'placeholder.add_guest.email' | translate"
        >
    </div>
    <div class="form-control">
      <input 
        type="text" 
        nz-input 
        formControlName="id_number" 
        (compositionstart)="compositionstart('id_number')"
        (compositionend)="compositionend('id_number')"
        (input)="checkDuplicateGuests('id_number')"
        [attr.placeholder]="'placeholder.add_guest.id' | translate"
        >
    </div>
    <div class="form-control">
      <button nz-button nzType="primary" (click)="clickCreateGuest()">{{ "modal.add_guest.btn.add_new" | translate }}</button>
    </div>
  </div>
  <div class="body">
    <div class="body-title">{{ "modal.add_guest.form_title" | translate }}</div>
    <div class="guest-list" *ngIf="listOfGuest?.length else empty">
      <div class="guest-item" 
        *ngFor="let guest of listOfGuest">
        <div class="name-column column">
          <div class="name">
            <span>
              {{ guest.name }} 
            </span>
            <img [src]="guest.gender === 2 ? '/assets/guest/female.png' : '/assets/guest/male.png'" class="sex">
          </div>
          <div class="tags" *ngIf="guest?.client_tags?.length">
            <span 
              class="tag" 
              [style.background]="tag.color"
              *ngFor="let tag of guest.client_tags">{{ tag.name }}</span>
          </div>
        </div>
        <div class="phone-column column">
          {{ guest.phone }}
        </div>
        <div class="email-column column">
          {{ guest.email }}
        </div>
        <div class="number-column column">
          {{ guest.id_number }}
        </div>
        <div class="operate-column column">
          <button nz-button (click)="clickExistGuest(guest)">{{ "modal.add_guest.btn.add_existed" | translate }}</button>
        </div>
      </div>
    </div>

    <ng-template #empty>
      <div class="empty-container">
        <!-- <nz-empty></nz-empty> -->
        <!-- 暂无数据 -->
        <img class="host-no-data-img-large" src="/assets/icon/no_data.png" />
        <p class="text">
          <!-- 暂无数据 -->
          {{ "word.no_data" | translate }}
        </p>
      </div>
    </ng-template>
  </div>
</div>